import { NextSeo } from 'next-seo';
import React from 'react';
import PageHeader from '../../components/PageHeader';
import TheRafflesPage from '../../components/TheRafflesPage';
import config from '../../config';
import firebase from '../../firebase';

function RafflesPage({ raffles }) {
  const description = ``;

  return (
    <>
      <NextSeo title={`Shitty Raffles - ${config.siteName}`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Shitty Raffles'}
          description='Enter raffles using Shitty Treats and other community tokens.'
          docsLink='https://docs.shittykitties.art/website-utilities/shitty-raffles'
        />

        <div className='mx-auto max-w-7xl px-4'>
          <TheRafflesPage raffles={raffles} />
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps({ params }) {
  const snapshot = await firebase
    .firestore()
    .collection('raffles')
    .where('endDate', '>', new Date(Date.now() - 3 * 24 * 60 * 60 * 1000))
    .get();
  const docs = snapshot.docs.map((doc) => ({
    ...doc.data(),
    startDate: doc.data().startDate.toDate().toString(),
    endDate: doc.data().endDate.toDate().toString(),
  }));

  return {
    props: {
      raffles: docs,
    },
  };
}

export default RafflesPage;
